import { ReducedVesselReport } from '@navstation-portal/reporting/data-model/vessel-reports';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const vesselReportsEvents = eventGroup({
  source: 'VesselReportsStore',
  events: {
    fetchVesselReports: type<string>(),
    fetchedVesselReports: type<ReducedVesselReport[]>(),
    // Raised by the report store once a save, submit, or delete succeeds.
    // Declared here rather than listening to reportEvents directly, which
    // would make this lib depend back on vessel-report and close a circular
    // dependency.
    reportSaved: type<{ report: ReducedVesselReport }>(),
    reportSubmitted: type<{ report: ReducedVesselReport }>(),
    reportDeleted: type<{ reportId?: string }>(),
    reset: type<void>(),
  },
});
